var _g, _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _path13, _path14, _path15, _polygon, _polygon2, _path16, _polygon3, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon4, _path25, _polygon5, _path26, _polygon6, _path27, _path28, _path29, _path30, _path31, _circle, _path32, _ellipse28, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect3, _rect4, _rect5, _polygon7, _circle2, _path50, _polygon8, _circle3, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorksheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 824.77942,
    height: 519.58568,
    viewBox: "0 0 824.77942 519.58568",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.34941,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.56317,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.77692,
    cy: 8.64507,
    rx: 8.45661,
    ry: 8.64507,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08834,15.47786c-.25977,0-.51904-.10059-.71484-.30078l-5.70605-5.83301c-.38037-.38867-.38037-1.00977,0-1.39844l5.70605-5.83252c.38721-.39453,1.021-.40088,1.41406-.01562,.39502,.38623,.40186,1.01953,.01562,1.41406l-5.02197,5.1333,5.02197,5.13379c.38623,.39453,.37939,1.02783-.01562,1.41406-.19434,.19043-.44678,.28516-.69922,.28516Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67672,15.47786c-.25244,0-.50488-.09473-.69922-.28516-.39502-.38623-.40186-1.01904-.01562-1.41406l5.02148-5.13379-5.02148-5.1333c-.38623-.39453-.37939-1.02783,.01562-1.41406,.39404-.38672,1.02783-.37939,1.41406,.01562l5.70557,5.83252c.38037,.38867,.38037,1.00977,0,1.39844l-5.70557,5.83301c-.1958,.2002-.45508,.30078-.71484,.30078Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.18654,1.0009h-10.60999c-1.21002,0-2.19,.97998-2.19,2.19V13.8109c0,1.21002,.97998,2.19,2.19,2.19h10.60999c1.21002,0,2.20001-.97998,2.20001-2.19V3.1909c0-1.21002-.98999-2.19-2.20001-2.19Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.18654,1.0009h-10.60999c-1.21002,0-2.19,.97998-2.19,2.19V13.8109c0,1.21002,.97998,2.19,2.19,2.19h10.60999c1.21002,0,2.20001-.97998,2.20001-2.19V3.1909c0-1.21002-.98999-2.19-2.20001-2.19Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.68654,1.5009h-10.60999c-1.21002,0-2.19,.97998-2.19,2.19V14.3109c0,1.21002,.97998,2.19,2.19,2.19h10.60999c1.21002,0,2.20001-.97998,2.20001-2.19V3.6909c0-1.21002-.98999-2.19-2.20001-2.19Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.76485,5.54088h-84.81c-1.48004,0-2.67004,1.20001-2.67004,2.67004s1.19,2.66998,2.67004,2.66998h84.81c1.46997,0,2.66998-1.20001,2.66998-2.66998s-1.20001-2.67004-2.66998-2.67004Z",
    fill: "#3f3d56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M645.03619,41.89927H179.74319c-.99774-.02133-1.78931-.84746-1.76797-1.84521,.02069-.96771,.80026-1.74727,1.76797-1.76796h465.293c.99774,.02133,1.78931,.84746,1.76794,1.84521-.02069,.96771-.80023,1.74727-1.76794,1.76796Z",
    fill: "#cacaca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 530.94389,
    y: 67.43251,
    width: 43.78723,
    height: 9.36339,
    rx: 4.68169,
    ry: 4.68169,
    fill: "#8e28f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M513.38756,86.15929h78.89996c2.58563,0,4.6817,2.09607,4.6817,4.68169h0c0,2.58562-2.09607,4.68169-4.6817,4.68169h-78.89996c-2.58563,0-4.6817-2.09607-4.6817-4.68169h0c0-2.58562,2.09607-4.68169,4.6817-4.68169Z",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 508.70586,
    y: 104.88606,
    width: 88.26337,
    height: 9.36339,
    rx: 4.68169,
    ry: 4.68169,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.89133,321.49714h-21.73145c-.58401,0-3.80096-1.70175-3.80096-3.80099v-12.07199c-.10394-9.13107,29.78879-9.72873,29.90155,0v12.07199c.00003,2.09924-2.26993,3.80099-4.36914,3.80099Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.01584,297.44132c-1.05417-.37717-2.17365-.53763-3.29132-.47174,.29892-.09885,.57355-.25977,.80588-.47223-.20428-.00821-.40735-.03555-.60654-.08173-.21948-.0412-.42612-.13367-.60312-.26984-.17798-.1402-.2731-.36081-.2529-.58649,.04062-.27612,.29861-.50342,.27213-.78125-.03036-.31839-.39774-.47336-.59436-.72562-.24625-.39053-.20392-.89694,.10373-1.24118,.18683-.21753,.4155-.39529,.67239-.52267-.43384-.11145-.88959-.10486-1.32001,.01913,.4613-.35709,.66623-.95416,.52142-1.51926-.24359-.70346-.82178-1.23923-1.54172-1.42862-.71024-.17902-1.44534-.23837-2.17508-.17566,.62027-.19058,.52676-1.16232,.05264-1.60532s-1.15225-.62799-1.59937-1.09827-.41092-1.47418,.23325-1.55228l-.07919-.22916c-1.2829-.4791-2.71127,.17255-3.19037,1.45544-.04099,.1098-.07416,.22238-.09924,.33688-.11801,.73529,.10187,1.54865-.26706,2.19556-.47037,.82477-1.61218,.91809-2.55725,.82669-.92789-.23798-1.91205-.10367-2.74222,.37427-.68643,.57178-.77939,1.59174-.20761,2.27817,.31735,.38098,.79187,.59537,1.28751,.5817-.62186,.0043-1.24075,.086-1.84244,.24319l.5795,.22458c.12891,.03986,.24789,.10666,.349,.19601,.10165,.09366,.1329,.24142,.07788,.36823-.09265,.168-.33206,.1622-.52176,.13367l-1.25986-.18954c.25058,.08362,.38593,.35452,.30231,.6051-.08359,.25058-.35452,.38596-.6051,.30234-.06427-.02145-.12326-.0563-.17303-.10226,.12939,.15109,.23343,.32217,.30807,.50656,.07401,.18802,.05219,.40021-.0585,.56924-.25613,.23477-.63321,.28067-.93817,.1142-.10254-.03943-.20575-.08533-.30969-.12735,.00208,.03644,.00485,.07294,.00912,.1095,.06961,.48407,.33929,.91663,.74329,1.19223-.57117,.0665-1.09708,.34344-1.47507,.77676-.65573,.81445-.69528,1.96396-.09708,2.82156-.63559-.28107-1.33206-.39648-2.02432-.33539-.71161,.08759-1.24487,.69421-1.24051,1.41119,.11469,.87823,1.20218,1.19931,2.08112,1.3082,6.91153,.85065,13.90137,.84982,20.81268-.0025,.93896-.06348,1.85852-.29739,2.71365-.69034,.86499-.40936,1.46027-1.23297,1.57758-2.18274-.03726-1.14438-.75934-2.15393-1.83026-2.55899Z",
    fill: "#8e28f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.14609,307.61497c-.15762-.68335-.76764-1.16635-1.46893-1.16306-.668,.01755-1.26508,.49457-1.92099,.39014-.54468-.08673-.97256-.56219-1.52036-.48959-.50171,.06647-.77145,.55682-1.14606,.82059h-.96094c-.37411-.29449-.55801-.89114-1.07678-1.05844-.78159-.25201-1.40863,.62991-2.22717,.78595-.47385,.05261-.95255-.03879-1.37366-.2623-.41223-.22385-.85977-.37537-1.32318-.448-.41617-.06253-.83121,.11972-1.06677,.46844,.02542-.24954-.29886-.49426-.62817-.51001-.36789,.01346-.72571,.12369-1.03741,.31955-.31287,.19583-.67468,.29932-1.04376,.29855-.81772-.0712-1.21872-1.0267-2.04099-1.03708-1.035-.01309-1.44907,1.46124-2.4726,1.33557-.53223-.06534-.81946-.54861-1.29401-.75528-.50357-.15472-1.04123-.15997-1.54773-.01511l-2.42078,.45316c-.70953,.19592-1.45792,.20325-2.17114,.0213-.51926-.18784-1.02359-.5947-1.55899-.43985-.46634,.13486-.694,.6572-1.18777,.68433-.31546-.03986-.61945-.14389-.89316-.30569-.52344-.18539-1.10699-.03818-1.47989,.37329-.27103,1.1041-.31491,2.25174-.129,3.37329-.00735,.23907,.01157,.47824,.05643,.71317l2.43475,9.74323c.28625,1.49429,1.02515,2.57474,2.5466,2.57474h23.66412c1.52145,0,2.82855-1.08044,3.11481-2.57474l2.43475-9.74323c.00482-.02524,.00793-.05032,.01218-.0755,.05756-1.16605-.03433-2.33469-.27341-3.47742Z",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.21304,306.88175l.47314,6.14999c.15771,2.04999-.07574,4.07156,.082,6.12155,.08881,1.1546,.56879,2.33768,.65762,3.49228,.01044,.13583,.2236,.13699,.21307,0l-.47314-6.14999-.47311-6.14999-.26648-3.46381c-.01044-.13583-.2236-.13699-.21307,0l-.00003-.00003Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.32263,307.12522l.18436,6.06033,.18436,6.06033,.10352,3.40228c.00415,.13678,.21725,.13739,.21307,0l-.18436-6.06033-.18436-6.06033-.10352-3.40228c-.00415-.13678-.21722-.13736-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.30405,307.48878l-.05609,5.85687-.05573,5.82138-.03159,3.30115c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l.05609-5.85687,.05573-5.82138,.03159-3.30115c-.00201-.05884-.05136-.10489-.1102-.10287-.056,.00192-.10095,.04688-.10287,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.3118,307.30964l.11661,5.9292,.11591,5.89368,.06564,3.3374c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l-.11661-5.9292-.11591-5.89371-.06564-3.3374c-.00201-.05884-.05136-.10489-.1102-.10287-.056,.00192-.10095,.04688-.10287,.10287v.00003Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.69519,307.06614l.13333,6.08734,.13333,6.08734,.07462,3.40747c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l-.13333-6.08734-.1333-6.08734-.07471-3.40747c-.00247-.05881-.05215-.10449-.11096-.10205-.05539,.00232-.09973,.04669-.10205,.10205Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M190.33392,307.25071l.46469,6.13348,.46335,6.11581,.26114,3.44678c.01031,.13589,.22345,.13699,.21307,0l-.46472-6.13348-.46335-6.11581-.26114-3.44678c-.01025-.13586-.22342-.13699-.21304,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M194.37729,307.96549l.28021,5.61206c.09341,1.8707-.38141,3.74136-.28799,5.61206l.15735,3.15125c.00681,.13647,.21991,.1373,.21307,0-.09341-1.87067,.38141-3.74136,.28799-5.61206l-.28021-5.61206-.15732-3.15125c-.00684-.13647-.21994-.13727-.2131,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.03127,
    cy: 292.02174,
    rx: 0.81679,
    ry: 0.56821,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.21609,
    cy: 293.30021,
    rx: 0.81679,
    ry: 0.56821,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.97154,
    cy: 296.07017,
    rx: 0.81679,
    ry: 0.56821,
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.72574,
    cy: 297.02815,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.00255,
    cy: 297.83613,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.424,
    cy: 299.58677,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.55545,
    cy: 299.01685,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.83226,
    cy: 299.82484,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.25369,
    cy: 301.57548,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.89343,
    cy: 297.43276,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-141.03698 433.06354) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.64575,
    cy: 300.56858,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-145.22084 434.53534) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.53649,
    cy: 295.79394,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-141.44874 429.31353) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.50441,
    cy: 295.72818,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-134.50325 437.1501) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.25673,
    cy: 298.86402,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-138.68711 438.6219) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.14744,
    cy: 294.08934,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-134.915 433.40003) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.02486,
    cy: 292.25724,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-129.75135 435.66029) rotate(-82.1552)",
    fill: "#3f3d56"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.91739,
    cy: 287.48406,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(-125.97967 430.44036) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.03246,
    cy: 226.22976,
    rx: 7.55667,
    ry: 5.25681,
    fill: "#e6e6e6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.00081,
    cy: 238.05756,
    rx: 7.55667,
    ry: 5.25681,
    fill: "#3f3d56"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.97652,
    cy: 263.68449,
    rx: 7.55667,
    ry: 5.25681,
    fill: "#ff6584"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.14702,
    cy: 290.9463,
    rx: 4.77582,
    ry: 3.3223,
    fill: "#e6e6e6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.46303,
    cy: 298.42146,
    rx: 4.77582,
    ry: 3.3223,
    fill: "#3f3d56"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 344.74812,
    cy: 276.2895,
    rx: 4.77581,
    ry: 3.32229,
    transform: "translate(23.98955 580.10046) rotate(-82.1552)",
    fill: "#e6e6e6"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.20744,
    cy: 305.3027,
    rx: 4.77582,
    ry: 3.3223,
    transform: "translate(-14.71867 593.7197) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.94455,
    cy: 261.12911,
    rx: 4.7758,
    ry: 3.3223,
    transform: "translate(20.18004 545.40934) rotate(-82.15511)",
    fill: "#ff6584"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.66156,
    cy: 260.52033,
    rx: 4.77582,
    ry: 3.3223,
    transform: "translate(84.43761 617.91009) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.85552,
    cy: 245.35872,
    rx: 4.77582,
    ry: 3.3223,
    transform: "translate(80.62768 583.21599) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M579.97467,500.49217c1.30988,.06018,2.42053-.95288,2.48077-2.26276,.0321-.69934-.24603-1.3772-.76007-1.85242-.05988-.23798-.10284-.40881-.16266-.64679,1.29041-3.27808,4.99384-4.88934,8.27191-3.59894,1.60815,.63306,2.89056,1.89154,3.55383,3.48743,2.8139,6.58643,6.45569,13.40485,4.64453,20.6593,11.9632-25.35449,7.89478-56.89313-9.7851-78.57587-5.0462-2.68164-8.65869-7.44574-9.87909-13.02844,2.41864,.81952,5.43414-1.14783,3.6156-3.69543-.78827-.97369-1.58411-1.9397-2.37231-2.91345,9.18738-9.78448,20.13397,5.59326,10.02136,18.79932,3.30811,4.14758,6.17365,8.62964,8.54974,13.37311-.54871-5.03693,.1062-10.13208,1.91089-14.86652,1.82898-4.41229,5.2572-8.12836,8.27618-11.94275,2.23193-2.86121,6.36072-3.37128,9.22192-1.13934,1.41772,1.10596,2.32025,2.74457,2.49725,4.53387-3.38751,1.1134-3.82764,6.00665,.0473,6.67639-1.19904,11.14294-8.0097,20.90015-18.05597,25.86761,3.64594,10.22986,5.06958,21.11926,4.17615,31.94257,1.74268-12.64917,15.32074-15.71881,24.81122-20.74628,1.71869-1.10217,4.00543-.60242,5.1076,1.11627,.49945,.77881,.68872,1.71667,.5304,2.62823-1.30988,.53259-2.5636,1.19403-3.74274,1.97449-1.47913,.99445-1.87201,2.99963-.87756,4.47876,.54028,.80353,1.41278,1.32208,2.37683,1.41248-4.78381,11.83966-17.15186,19.79004-29.85455,19.7453-1.2207,5.30463-2.98944,10.46808-5.27765,15.40704h-18.85333c-.06763-.20947-.12842-.42578-.18927-.63525,1.74512,.10968,3.49707,.00531,5.2168-.31085-4.617-5.46649-8.18768-8.25537-5.50055-15.88684l.00055-.00024Z",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.82043,500.20988c-1.30988,.06024-2.42056-.95282-2.48077-2.26276-.03217-.69934,.24597-1.3772,.76004-1.85242l.16269-.64679c-1.29041-3.27808-4.99387-4.88934-8.27191-3.59894-1.60812,.63306-2.89056,1.89154-3.55383,3.48743-2.81387,6.58636-6.45569,13.40485-4.64453,20.6593-11.96317-25.35449-7.89478-56.89307,9.78513-78.57587,5.04623-2.6817,8.65872-7.4458,9.87912-13.0285-2.41858,.81952-5.43411-1.14783-3.61563-3.69543,.78824-.97369,1.58411-1.9397,2.37228-2.91345-9.18741-9.78448-20.134,5.59326-10.02136,18.79932-3.30814,4.14764-6.17361,8.62976-8.54974,13.37323,.54871-5.03693-.10617-10.13208-1.91083-14.86652-1.82901-4.41229-5.25723-8.12836-8.27618-11.94275-2.23193-2.86121-6.36075-3.37128-9.22192-1.13934-1.41772,1.10596-2.32025,2.74457-2.49725,4.53387,3.38754,1.1134,3.82761,6.00665-.0473,6.67633,1.19901,11.14294,8.00974,20.90027,18.056,25.86768-3.6459,10.22986-5.06958,21.11926-4.17612,31.94257-1.74268-12.64917-15.32074-15.71881-24.81119-20.74628-1.71866-1.10217-4.0054-.60242-5.10757,1.11627-.49945,.77881-.68872,1.71661-.53043,2.62817,1.30988,.53265,2.5636,1.19409,3.74274,1.97455,1.47906,.99451,1.87192,2.99969,.87741,4.47876-.54022,.80353-1.41266,1.32196-2.37665,1.41241,4.78378,11.83966,17.15182,19.7901,29.85452,19.7453,1.2207,5.30463,2.98941,10.46808,5.27756,15.4071h18.85333c.0676-.20947,.12842-.42578,.18924-.63525-1.74512,.10974-3.4971,.00531-5.21683-.31079,4.617-5.46649,8.18768-8.25537,5.50058-15.88684l-.00058-.00037Z",
    fill: "#f2f2f2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M258.05597,279.49098l-2.00534-11.62341,30.48767-13.767,6.58411-11.65707c-.63702-3.06476,1.33105-6.06561,4.39578-6.70264,3.06476-.63702,6.06564,1.33105,6.70264,4.39578,.49884,2.39996-.60162,4.8486-2.72751,6.06894l-10.83087,16.745-32.60648,16.54041Z",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.78899 269.98808 262.51799 262.97608 266.153 276.62309 256.61598 283.69209 248.78899 269.98808",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.97998 501.95207 226.28099 501.95207 230.22998 469.93208 217.97899 469.93208 217.97998 501.95207",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M229.0437,502.69938v-5.62781l-2.1824,.1333-8.88379,.52625-2.05606,.12628-1.57184,18.84827-.0842,1.0105h5.89444l.18948-1.00348,.85608-4.56122,2.21045,4.56122,.48419,1.00348h15.62735c1.93539-.01227,3.50021-1.5802,3.50861-3.51562,.65967-3.08044-12.33624-9.73981-13.99231-11.50116Z",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.63998 472.06407 126.42699 476.84406 148.09598 452.94209 138.07898 445.88609 119.63998 472.06407",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.49695,478.43607l3.24115-4.60083-1.8609-1.14789-7.5657-4.68604-1.75357-1.08087-12.14001,14.50348-.65079,.77759,4.81879,3.39471,.73279-.71118,3.32672-3.23584-.81979,5.00183-.18207,1.09918,12.77554,9c1.58926,1.10461,3.77151,.724,4.89301-.85339,2.31342-2.13855-4.47568-15.06714-4.81516-17.46075Z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.81567,294.72105l-10.6853-4.9949-21.30853,25.78714-12.97931,3.28256c-2.78888-1.42148-6.20206-.31299-7.62354,2.47586-1.42151,2.78888-.31302,6.20209,2.47586,7.62354,2.18393,1.11316,4.83594,.69623,6.57297-1.03333l19.00586-6.03989,24.54199-27.10098Z",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.04306,336.25883s-17.53183,11.41608-12.896,19.00201c.15991,.26166-37.34378,52.32874-37.34378,52.32874l-42.05444,45.33997,14.45621,13.14203s39.95187-41.60266,46.65414-48.62549,35.97662-42.15619,35.97662-42.15619l1.07684,43.41913-11.20685,60.16602,16.73312-1.06091,16.28653-60.36157,6.0116-68.37421-33.694-12.81952Z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232.53104,267.74387l-7.37244,5.58707-8.40311,17.93466,8.08032,10.97412s6.79694,11.7796-4.08258,23.18738-19.23383,23.59192-10.52585,23.15692,43.97644,17.50323,44.20853,2.80688,.70172-25.96375,.70172-25.96375l9.24658-23.45258s5.50891-13.99072,1.64114-18.17871-9.04642-9.53961-9.04642-9.53961l-9.41757-9.41757h-8.5036l-6.52673,2.90518Z",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M246.29358,233.28449c16.53952,9.41165,2.9614,34.24429-13.88647,25.40158-16.53891-9.41132-2.96082-34.24393,13.88647-25.40158Z",
    fill: "#a0616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M255.1377,238.50294c-1.15891,1.50729-3.58014,.80054-8.32169,1.8761,.01038-1.60718-.17529-3.20966-.55292-4.77188-.35278,1.93427-1.12589,3.76752-2.26477,5.37027-4.11719,.4566,.92993,12.96442-1.17813,22.16058-2.71613-19.40091-8.42899-14.31799-5.54288-10.46991,1.84763,2.4635,.61588,9.854-4.927,6.15875-9.14554,4.3465-22.17154-17.24454-7.73474-27.37039-.258-5.4733,5.83212-6.33795,9.58234-4.65515,9.10129-6.77988,19.4993,1.90744,20.93979,11.70163Z",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212.70093,224.34638c-3.68231,22.64008-23.41919-4.16373-32.69934,18.11636-2.91782,8.06854,2.08838,13.84052,5.255,20.53775,.72272,5.50391-6.43744,8.29633-7.18741,13.36267-.20874,11.61514,18.53018,10.90436,23.7688,3.57626,5.38269-7.67126-1.04501-17.96353,2.19037-26.1976,4.54733-11.43185,23.04037-11.51678,24.65143-24.81677-3.12009-4.44312-11.51001-9.53189-15.97885-4.57867Z",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M227.61792,226.55872c-.12045,.05072-.24094,.10141-.34869,.15851h-.00635c-.10141,.05072-.20288,.10141-.30432,.15848-.0127,.00635-.01901,.0127-.03171,.01907-.13315-.12683-.26627-.25363-.40576-.38046-.03607,.20654-.02744,.4184,.02536,.62131l.01901,.07614c.1268,.13312,.25992,.25992,.39944,.39307,.12683-.09512,.24728-.19653,.37405-.29166,.07611-.06339,.15219-.1268,.23462-.19019,.01266-.16486,.03168-.35507,.05069-.5643l-.00635,.00003Zm3.81686-7.05035c-2.82776-.6467-3.74078,3.04965-4.0134,4.83127-1.02713-6.46701-5.30045-4.43182-3.82315-.01901,.47089,1.30649,1.21188,2.49902,2.17471,3.49982,.13315,.15216,.27899,.30432,.43112,.45654-.1712,.8876,.6911,.65936,1.85767-.15851,.86142-.61267,1.65808-1.31161,2.37759-2.086,2.32687-2.44101,4.14023-5.70624,.99545-6.52411Zm.08878,3.63931c-.87241,1.12497-1.85123,2.16324-2.92285,3.1004-.33609,.30435-.67847,.59604-1.02713,.875-.00635,.05704-.00635,.10776-.0127,.15216-.02448,.06161-.05417,.121-.08878,.17752-.35507,.64038-.75449,.29169-.90665-.24088-.0127-.01907-.03168-.03812-.04437-.05707-.50665-.52341-.94742-1.10681-1.31244-1.73721-2.61853-4.53964,1.59775-7.62735,1.38852,.84958-.03854,.07779-.06424,.16129-.07608,.24728-.03607,.20654-.02744,.4184,.02536,.62131l.01901,.07614c.1268,.13312,.25992,.25992,.39944,.39307,.12683-.09512,.24728-.19653,.37405-.29166,.07611-.06339,.15219-.1268,.23462-.19019,.01266-.16486,.03168-.35507,.05069-.5643v-.00635c.16486-1.69919,.61499-4.75519,1.44562-5.58575,1.82599-1.40125,4.19083,.11411,2.45361,2.181l.00006-.00006Zm-3.90561,3.41107c-.12045,.05072-.24094,.10141-.34869,.15851h-.00635c-.10141,.05072-.20288,.10141-.30432,.15848-.0127,.00635-.01901,.0127-.03171,.01907-.13315-.12683-.26627-.25363-.40576-.38046-.03607,.20654-.02744,.4184,.02536,.62131l.01901,.07614c.1268,.13312,.25992,.25992,.39944,.39307,.12683-.09512,.24728-.19653,.37405-.29166,.07611-.06339,.15219-.1268,.23462-.19019,.01266-.16486,.03168-.35507,.05069-.5643l-.00635,.00003Z",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.91399 503.28208 567.79497 505.12907 556.80498 474.69007 568.78899 471.96409 575.91399 503.28208",
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M578.12781,511.68632l-24.9679,5.68085-.0719-.31573c-1.22095-5.36707,2.13971-10.70789,7.50665-11.9295l.00061-.00012,3.77332-4.4978,9.29669,1.52405,2.1795-.49591,2.28302,10.03418Z",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.791 487.28108 674.77898 491.77107 654.12401 466.85807 664.47398 460.23109 681.791 487.28108",
    fill: "#ffb6b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M686.72253,494.43827l-21.565,13.80664-.17462-.27271c-2.96765-4.63562-1.61591-10.79932,3.01935-13.76758l.00055-.00031,2.02563-5.51044,9.26306-1.71686,1.88251-1.2052,5.54852,8.66644Z",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "570.50999 351.65409 564.40196 367.58408 535.74596 424.10807 560.92497 489.86207 573.91997 486.43208 563.21001 424.10807 593.93797 386.77107 611.77898 425.13307 663.033 481.64308 674.86101 473.75807 636.74901 415.27607 611.36998 341.11109 570.50999 351.65409",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M601.33215,276.51133l-10.05536-10.80334-17.2489-2.37299-21.13501,14.79581,.21289,16.37701,10.44788,38.59091s-3.97961,27.72577,7.13599,27.44769,17.17444-5.81982,21.70172-4.69171,23.77234,5.92914,24.992,.90021,7.7027-1.42816,7.41809-6.18549-17.55054-39.04929-17.55054-39.04929l3.02148-24.138c.66473-5.31064-3.10144-10.15463-8.41211-10.8194h0c-.1756-.02197-.35162-.03915-.5282-.05148l.00006,.00006Z",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M670.72302,344.57823c-3.32751,.70618-6.59747-1.41888-7.30365-4.7464-.07532-.3548-.11914-.71558-.13092-1.07812l-46.23224-18.20187,8.79834-7.20822,43.83032,18.97961c3.41815,.11499,6.09589,2.97913,5.98096,6.39728-.09625,2.86011-2.13965,5.2818-4.94281,5.85773Z",
    fill: "#ffb6b6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M605.23993,278.51405s-7.87592-.06064-8.84296,8.9043,15.54596,31.70181,18.09778,35.4462c.79907,1.17252,4.23279,2.50641,8.57288,3.78564,1.94843,.57428,4.07953,1.13757,6.23694,1.67035,1.24841,.30829,1.80646,2.37762,3.04218,2.66168,1.22894,.28247,3.1358-1.22028,4.29242-.9693,5.48981,1.19141,9.82874,1.98633,9.82874,1.98633l10.26398-6.99506c-5.17822-7.64526-15.08337-10.7731-26.30524-12.64261l-25.18671-33.84753Z",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M489.35364,236.88065c.51788,3.36197,3.66321,5.66754,7.02515,5.14963,.35846-.05521,.71136-.142,1.05457-.25931l33.39368,36.79117,3.62561-10.78073-33.27045-34.26947c-1.31793-3.15598-4.9447-4.646-8.10065-3.32809-2.64075,1.10275-4.18195,3.87134-3.72791,6.69684v-.00003Z",
    fill: "#ffb6b6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M574.3252,274.72694s2.84564,7.34415-5.19598,11.423-35.15265-3.31281-39.55798-4.37338c-1.37952-.33209-3.84283-3.07101-6.57605-6.67688-1.22699-1.61884-2.50848-3.41238-3.77063-5.2413-.73035-1.05838-2.86328-.8475-3.56647-1.90256-.69934-1.04929,.03076-3.36475-.61353-4.35754-3.05817-4.71225-5.33801-8.48849-5.33801-8.48849l2.90729-12.0759c8.98352,2.13544,15.4162,10.29123,21.13837,20.1239l40.573,11.56915Z",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 582.99644,
    cy: 244.17498,
    r: 16.4118,
    fill: "#ffb6b6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M601.73065,234.77793c-1.71692-2.767-4.86932-4.30325-8.10657-3.95062-.88232-6.04993-6.50201-10.23907-12.55194-9.35675-2.24921,.328-4.3429,1.34045-5.9967,2.89975-.98572-.69403-2.2627-.82181-3.36639-.33688-1.08093,.49149-2.0213,1.24628-2.73499,2.19528-3.67175,4.57892-4.52826,10.80594-2.22906,16.20615-.38385-1.39532,1.01453-2.70801,2.42743-3.02112,1.41278-.31311,2.89478-.01688,4.32751-.22079,1.8363-.26129,3.487-1.32654,5.32617-1.56628,1.55963-.10141,3.12415,.09964,4.60742,.5921,1.48303,.49237,3.04523,.70215,4.60559,.61847,1.54797-.18381,3.54193,5.68253,3.5152,9.81439-.00507,.78299,.15619,1.78836,.92139,1.95447,.94238,.20462,1.4884-1.09601,2.38538-1.45041,.85919-.24625,1.75909,.23227,2.03534,1.08231,.22937,.8436,.03699,1.74603-.51654,2.4227-.55133,.66116-1.20587,1.22891-1.93823,1.68137l.36945,.30725c.72321,.76419,1.88654,.90869,2.77478,.3447,.84692-.57361,1.53278-1.35455,1.99225-2.26843,1.7312-2.67712,2.96881-5.64276,3.65417-8.75632,.67603-3.14352,.13971-6.42639-1.50165-9.19131Z",
    fill: "#2f2e41"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.74529,
    cy: 228.4219,
    rx: 4.77582,
    ry: 3.3223,
    transform: "translate(128.39701 604.14482) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M682.59534,340.97685h-21.73145c-.58398,0-3.80103-1.70172-3.80103-3.80103v-12.07199c-.10394-9.13107,29.78882-9.72873,29.90155,0v12.07199c.00006,2.0993-2.2699,3.80103-4.36908,3.80103Z",
    fill: "#e6e6e6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M683.71985,316.92103c-1.0542-.37717-2.17365-.53763-3.29132-.47174,.29895-.09882,.57355-.25977,.80591-.47223-.20428-.00821-.40741-.03555-.60657-.08173-.21948-.0412-.42615-.13367-.60315-.26984-.17798-.1402-.27313-.36081-.25293-.58649,.04065-.27612,.29865-.50342,.27216-.78125-.0304-.31839-.39777-.47336-.59436-.72562-.24622-.39053-.20392-.89694,.10376-1.24118,.18683-.21753,.41547-.39529,.67236-.52267-.43384-.11145-.88959-.10486-1.32001,.01913,.4613-.35709,.6662-.95416,.52142-1.51926-.24359-.70346-.82178-1.23923-1.54175-1.42862-.71027-.17902-1.44537-.23837-2.17511-.17566,.6203-.19058,.52673-1.16232,.05261-1.60532s-1.15222-.62799-1.59937-1.09827-.41095-1.47418,.23322-1.55228l-.07916-.22916c-1.2829-.47906-2.7113,.17255-3.19037,1.45547-.04102,.1098-.07416,.22235-.09924,.33685-.11798,.73529,.10187,1.54865-.26709,2.19556-.4704,.82477-1.61218,.91809-2.55725,.82669-.92792-.23801-1.91205-.10367-2.74225,.37427-.6864,.57178-.77936,1.59174-.20758,2.27817,.31732,.38098,.79187,.59537,1.28748,.5817-.62189,.0043-1.24078,.086-1.84247,.24319l.57947,.22458c.12891,.03986,.24786,.10666,.349,.19601,.10168,.09366,.13293,.24142,.07788,.36823-.09265,.168-.33197,.1622-.52179,.13367l-1.25983-.18954c.25061,.08362,.38593,.35452,.30231,.6051s-.35449,.38596-.6051,.30234c-.06427-.02145-.12323-.0563-.17303-.10226,.12939,.15109,.2334,.32217,.30798,.50656,.07397,.18799,.05219,.40021-.05847,.56924-.2561,.23477-.63318,.28067-.93817,.1142-.10254-.03943-.20575-.08533-.30969-.12735,.00208,.03644,.00488,.07294,.00909,.1095,.06964,.48404,.33929,.91663,.74329,1.19223-.57117,.06653-1.09705,.34344-1.47504,.77676-.6557,.81448-.69525,1.96396-.09705,2.82156-.63556-.28107-1.33203-.39645-2.02429-.33539-.71161,.08762-1.24487,.69421-1.24048,1.41119,.11469,.87823,1.20215,1.19931,2.08112,1.3082,6.91156,.85065,13.90137,.84982,20.81268-.0025,.93896-.06345,1.85852-.29739,2.71368-.69034,.86499-.40936,1.46027-1.23297,1.57758-2.18274-.03723-1.14432-.75922-2.15387-1.83008-2.55899Z",
    fill: "#8e28f5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M688.8501,327.0947c-.15765-.68335-.76764-1.16635-1.46893-1.16306-.66803,.01755-1.26508,.4946-1.92102,.39014-.54468-.08673-.97253-.56219-1.52039-.48959-.50171,.06647-.77142,.55682-1.14606,.82056h-.96094c-.37408-.29449-.55798-.89114-1.07678-1.05844-.78156-.25201-1.40863,.62991-2.22717,.78595-.47382,.05264-.95251-.03879-1.37366-.2623-.41223-.22385-.85974-.37537-1.32318-.448-.41614-.06253-.83118,.11972-1.06677,.46844,.02545-.24954-.29883-.49426-.62817-.51001-.36786,.01346-.72571,.12369-1.03741,.31955-.31287,.19583-.67468,.29932-1.04376,.29855-.81775-.0712-1.21875-1.0267-2.04102-1.03708-1.03497-.01309-1.4491,1.46127-2.4726,1.3356-.53223-.06537-.81946-.54861-1.29401-.75528-.5036-.15472-1.04126-.15997-1.54773-.01511l-2.42078,.45316c-.70953,.19589-1.45789,.20328-2.17114,.0213-.51923-.18784-1.02362-.5947-1.55902-.43985-.46637,.13486-.69397,.65717-1.18781,.68433-.31549-.03986-.61945-.14389-.89319-.30569-.52344-.18542-1.10706-.03821-1.47992,.37326-.271,1.10406-.31494,2.25171-.12903,3.37329-.00732,.23907,.0116,.47821,.05646,.71313l2.43475,9.74323c.28625,1.49426,1.02515,2.57471,2.54657,2.57471h23.66412c1.52142,0,2.82855-1.08044,3.11481-2.57471l2.43475-9.74323c.00482-.02527,.00793-.05029,.01215-.0755,.05762-1.16602-.03412-2.33466-.27313-3.47736Z",
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M659.91705,326.36143l.47314,6.15002c.15771,2.04999-.07574,4.07153,.08197,6.12158,.08881,1.1546,.56879,2.33765,.65765,3.49225,.01044,.13586,.22363,.13702,.21307,0l-.47314-6.15002-.47314-6.15002-.26648-3.46381c-.01044-.13583-.22363-.13699-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M664.02667,326.60496l.18439,6.0603,.18439,6.0603,.10352,3.40228c.00415,.13678,.21729,.13739,.21307,0l-.18439-6.0603-.18439-6.0603-.10352-3.40228c-.00415-.13678-.21729-.13739-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M668.00806,326.96848l-.05609,5.85687-.05573,5.82135-.03162,3.30115c.00201,.05884,.05139,.10492,.11023,.10284,.05597-.00189,.10089-.04688,.10284-.10284l.05609-5.85687,.05573-5.82135,.03162-3.30115c-.00201-.05884-.05139-.10492-.11023-.10284-.05597,.00189-.10089,.04688-.10284,.10284Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M671.01581,326.78935l.11664,5.9292,.11591,5.89368,.06561,3.3374c.00201,.05884,.05139,.10492,.11023,.10284,.05597-.00189,.10089-.04688,.10284-.10284l-.11664-5.9292-.11591-5.89368-.06561-3.3374c-.00201-.05884-.05139-.10492-.11023-.10284-.05597,.00189-.10089,.04688-.10284,.10284Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M675.39917,326.54588l.1333,6.08734,.1333,6.08734,.07465,3.40747c.00201,.05884,.05139,.10492,.11023,.10284,.05597-.00189,.10089-.04688,.10284-.10284l-.1333-6.08734-.1333-6.08734-.07465-3.40747c-.00201-.05884-.05139-.10492-.11023-.10284-.05597,.00189-.10089,.04688-.10284,.10284Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M679.03796,326.73039l.46472,6.13348,.46338,6.11584,.26117,3.44678c.01031,.13586,.22345,.13702,.21307,0l-.46472-6.13348-.46338-6.11584-.26117-3.44678c-.01031-.13586-.22345-.13696-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M683.0813,327.44517l.28021,5.61206c.09338,1.87067-.38141,3.74139-.28802,5.61206l.15735,3.15125c.00684,.13647,.21991,.13727,.21307,0-.09338-1.87067,.38141-3.74139,.28802-5.61206l-.28021-5.61206-.15735-3.15125c-.00677-.13641-.21991-.13727-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.73528,
    cy: 311.50144,
    rx: 0.81677,
    ry: 0.56821,
    fill: "#e6e6e6"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.92009,
    cy: 312.77989,
    rx: 0.81677,
    ry: 0.56821,
    fill: "#3f3d56"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.67558,
    cy: 315.54987,
    rx: 0.81677,
    ry: 0.56821,
    fill: "#ff6584"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.42973,
    cy: 316.50785,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.70659,
    cy: 317.31584,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.12798,
    cy: 319.06648,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 680.25945,
    cy: 318.49656,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 683.53624,
    cy: 319.30454,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.95769,
    cy: 321.05515,
    rx: 0.51624,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 666.59747,
    cy: 316.9125,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(261.66455 934.01463) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 665.34602,
    cy: 320.04721,
    rx: 0.51623,
    ry: 0.3591,
    transform: "translate(257.48079 935.48323) rotate(-82.1552)",
    fill: "#3f3d56"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.24047,
    cy: 315.27368,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(261.25274 930.26457) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 672.20844,
    cy: 315.20786,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(268.19833 938.10113) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.96075,
    cy: 318.3437,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(264.01447 939.57293) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 669.85146,
    cy: 313.56899,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(267.7866 934.35103) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 673.73072,
    cy: 311.73836,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(272.94987 936.61322) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 672.62142,
    cy: 306.96377,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(276.72188 931.39142) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M824.77942,518.4459c-.76733,2.27271-823.95154,.81158-824.77942-1.45551,.7663-2.27826,823.95044-.8172,824.77942,1.45551Z",
    fill: "#ccc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M320.31161,400.32646c-14.44989,0-26.16382-11.71399-26.16379-26.16382,0-14.44989,11.71396-26.16382,26.16385-26.16382s26.16379,11.71393,26.16379,26.16382-11.71393,26.16382-26.16385,26.16382h0Z",
    fill: "#e6e6e6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M330.63519,371.58177h-7.74261v-7.74274c0-1.42542-1.15552-2.58093-2.58093-2.58093s-2.58093,1.15552-2.58093,2.58093v7.74274h-7.74271c-1.42538,0-2.5809,1.15552-2.5809,2.58087s1.15552,2.58093,2.5809,2.58093h7.74271v7.74274c.00342,1.42542,1.16171,2.57819,2.58713,2.57477,1.42056-.00342,2.57132-1.15417,2.57474-2.57477v-7.74274h7.74261c1.42542,0,2.58087-1.15552,2.58087-2.58093s-1.15546-2.58087-2.58087-2.58087Z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M396.85901,400.32646c-14.44989,0-26.16382-11.71393-26.16382-26.16382s11.71393-26.16382,26.16382-26.16382,26.16382,11.71393,26.16382,26.16382h0c0,14.44989-11.71393,26.16382-26.16382,26.16382Z",
    fill: "#e6e6e6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M407.18256,371.58177h-20.64722c-1.42542,0-2.58087,1.15552-2.58087,2.58087s1.15546,2.58093,2.58087,2.58093h20.64722c1.42542,0,2.58087-1.15552,2.58087-2.58093s-1.15546-2.58087-2.58087-2.58087Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M473.40643,400.32646c-14.44989,.00006-26.16382-11.71387-26.16388-26.16376s11.71387-26.16382,26.16376-26.16388,26.16382,11.71387,26.16388,26.16376v.00006c0,14.44983-11.71393,26.16376-26.16376,26.16382Z",
    fill: "#8e28f5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M488.12567,372.91972l-7.41736-10.82635c-.68665-1.00226-2.05579-1.25806-3.05804-.57141-1.0022,.68671-1.258,2.05579-.57135,3.05804l4.79706,7.00171h-18.79321c-1.42542,0-2.58093,1.15552-2.58093,2.58093s1.15552,2.58087,2.58093,2.58087h19.02924l-5.03308,7.34625c-.68439,1.00378-.42542,2.37231,.57837,3.0567,1.00055,.68213,2.36432,.42737,3.05103-.57007l7.41736-10.82635c.49115-.87952,.49115-1.95081,0-2.83032Z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 244.25908,
    y: 90.84098,
    width: 43.78726,
    height: 9.36339,
    rx: 4.68169,
    ry: 4.68169,
    fill: "#8e28f5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 222.02104,
    y: 109.56776,
    width: 88.26334,
    height: 9.36339,
    rx: 4.68169,
    ry: 4.68169,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 222.02104,
    y: 128.29453,
    width: 88.26334,
    height: 9.3634,
    rx: 4.68169,
    ry: 4.68169,
    fill: "#e6e6e6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.73698 228.82108 298.73698 228.82108 298.73698 153.77808 156.07999 153.77808 156.07999 151.77808 300.73698 151.77808 300.73698 228.82108",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.79007,
    cy: 146.9616,
    r: 27.78,
    fill: "#e6e6e6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.00031,161.41981c-.97263,0-1.88846-.45804-2.47186-1.2363l-7.5788-10.10526c-1.02393-1.36533-.74716-3.30215,.61816-4.32608s3.30215-.74716,4.32608,.61816h0l4.95831,6.61057,12.7348-19.10193c.94669-1.42004,2.8653-1.80374,4.28534-.85706s1.80374,2.8653,.85706,4.28534l-15.15762,22.73642c-.5564,.83438-1.48297,1.34702-2.48544,1.37512-.02869,.00049-.05737,.00101-.08603,.00101Z",
    fill: "#fff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "489.17097 224.86508 487.17097 224.86508 487.17097 147.82208 631.82799 147.82208 631.82799 149.82208 489.17097 149.82208 489.17097 224.86508",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.01073,
    cy: 143.00559,
    r: 27.78001,
    fill: "#e6e6e6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M650.22095,157.46381c-.97266,0-1.88849-.45804-2.47186-1.2363l-7.5788-10.10526c-1.02728-1.36276-.75537-3.30029,.60736-4.32761,1.36279-1.02731,3.30035-.75537,4.32764,.60739l.00922,.0123,4.95831,6.61057,12.7348-19.10193c.94672-1.42004,2.8653-1.80374,4.28534-.85706s1.80377,2.8653,.85706,4.28534h0l-15.15759,22.73639c-.5564,.83438-1.48297,1.34705-2.48547,1.37512-.02869,.00052-.05731,.00104-.086,.00104Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M308.68628,237.68815h-21.73145c-.58401,0-3.80099-1.70175-3.80099-3.80099v-12.07199c-.10394-9.13107,29.78879-9.72873,29.90155,0v12.07199c.00006,2.09921-2.2699,3.80099-4.36911,3.80099Z",
    fill: "#e6e6e6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M309.81079,213.6323c-1.05417-.37717-2.17365-.53763-3.29132-.47174,.29892-.09885,.57355-.25977,.80588-.47223-.20428-.00821-.40735-.03555-.60654-.08173-.21948-.0412-.42612-.13364-.60312-.26981-.17798-.1402-.2731-.36081-.2529-.58649,.04062-.27612,.29865-.50345,.27213-.78125-.03036-.31839-.39774-.47336-.59433-.72562-.24625-.3905-.20392-.89691,.10373-1.24115,.18683-.21753,.4155-.39529,.67239-.52267-.43384-.11145-.88959-.10486-1.32001,.01913,.4613-.35709,.66623-.95416,.52142-1.51926-.24359-.70346-.82178-1.23926-1.54172-1.42865-.71024-.17902-1.44534-.23837-2.17508-.17566,.62027-.19058,.52676-1.16232,.05264-1.60532s-1.15225-.62799-1.59933-1.09827-.41092-1.47421,.23325-1.55231l-.07919-.22916c-1.2829-.4791-2.7113,.17252-3.19037,1.45544-.04102,.1098-.07419,.22238-.09927,.33688-.11801,.73529,.10187,1.54865-.26706,2.19556-.47037,.82477-1.61218,.91809-2.55725,.82666-.92789-.23801-1.91205-.10367-2.74222,.37427-.68643,.57178-.77939,1.59174-.20761,2.27817,.31735,.38098,.79187,.59537,1.28751,.5817-.62186,.0043-1.24075,.086-1.84244,.24319l.5795,.22458c.12891,.03986,.24789,.10666,.349,.19601,.10165,.09366,.1329,.24142,.07788,.36823-.09265,.168-.332,.1622-.52176,.13367l-1.25983-.18954c.25058,.08362,.38593,.35452,.30231,.6051-.08359,.25058-.35452,.38596-.6051,.30234-.06427-.02145-.12326-.0563-.17303-.10226,.12939,.15109,.23343,.32217,.30804,.50656,.07401,.18802,.05219,.40021-.0585,.56924-.25613,.23477-.63321,.28067-.93817,.1142-.10257-.03943-.20575-.08533-.30972-.12735,.00208,.03644,.00485,.07294,.00912,.1095,.06964,.48404,.33932,.91663,.74329,1.19223-.57117,.0665-1.09708,.34344-1.47507,.77676-.65573,.81445-.69528,1.96396-.09708,2.82156-.63559-.28107-1.33206-.39645-2.02432-.33539-.71164,.08759-1.24487,.69424-1.24051,1.41122,.11469,.8782,1.20215,1.19931,2.08112,1.3082,6.91153,.85065,13.90134,.84982,20.81268-.0025,.93896-.06348,1.85852-.29739,2.71365-.69034,.86499-.40936,1.46027-1.23297,1.57758-2.18271-.03723-1.14438-.75931-2.15396-1.83026-2.55902Z",
    fill: "#8e28f5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M314.94104,223.80595c-.15762-.68338-.76764-1.16638-1.46893-1.16309-.668,.01755-1.26508,.4946-1.92099,.39017-.54471-.08673-.97256-.56219-1.52036-.48959-.50171,.06647-.77145,.55682-1.14606,.82059h-.96094c-.37411-.29449-.55795-.89114-1.07678-1.05844-.78159-.25201-1.40863,.62991-2.22717,.78592-.47385,.05261-.95258-.03879-1.37369-.2623-.4122-.22385-.85977-.3754-1.32318-.448-.41617-.06253-.83121,.11972-1.06677,.46844,.02545-.24957-.29883-.49426-.62814-.51001-.36789,.01346-.72571,.12369-1.03741,.31958-.31287,.1958-.67468,.29932-1.04376,.29855-.81775-.07123-1.21872-1.0267-2.04099-1.03708-1.035-.01309-1.44907,1.46124-2.4726,1.33557-.53223-.06537-.81946-.54861-1.29401-.75528-.50357-.15475-1.04123-.16-1.54773-.01511l-2.42078,.45316c-.70953,.19592-1.45792,.20325-2.17117,.0213-.51926-.18787-1.02359-.5947-1.55899-.43985-.46634,.13486-.694,.6572-1.18777,.68433-.31546-.03983-.61945-.14386-.89316-.30566-.52344-.18539-1.10703-.03821-1.47989,.37329-.271,1.1041-.31488,2.25174-.129,3.37329-.00735,.23907,.01157,.47824,.05643,.71317l2.43475,9.74323c.28625,1.49429,1.02515,2.57474,2.5466,2.57474h23.66409c1.52145,0,2.82855-1.08044,3.11481-2.57474l2.43475-9.74323c.00482-.02524,.00793-.05032,.01215-.0755,.05759-1.16608-.03427-2.33469-.27332-3.47745Z",
    fill: "#ccc"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M286.008,223.0727l.47314,6.14999c.15771,2.04999-.07574,4.07156,.082,6.12155,.08884,1.1546,.56882,2.33765,.65762,3.49225,.01044,.13586,.2236,.13699,.21307,0l-.47314-6.14999-.47314-6.14999-.26648-3.46381c-.01044-.13586-.2236-.13699-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M290.11758,223.3162l.18436,6.06033,.18436,6.06033,.10349,3.40228c.00418,.13681,.21725,.13739,.21307,0l-.18436-6.06033-.18436-6.06033-.10349-3.40228c-.00415-.13681-.21725-.13739-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M294.099,223.67976l-.05606,5.85687-.05573,5.82138-.03162,3.30115c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l.05606-5.85687,.05573-5.82138,.03162-3.30115c-.00201-.05884-.05136-.10489-.1102-.10287-.056,.00192-.10095,.04688-.10287,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.10675,223.50059l.11661,5.9292,.11591,5.89371,.06564,3.3374c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l-.11661-5.9292-.11591-5.89371-.06564-3.3374c-.00201-.05884-.05136-.10489-.1102-.10287-.056,.00192-.10095,.04688-.10287,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M301.49011,223.25715l.13333,6.08734,.13333,6.08734,.07462,3.4075c.00201,.05884,.05136,.10489,.1102,.10287,.056-.00192,.10095-.04688,.10287-.10287l-.13333-6.08734-.13333-6.08734-.07462-3.4075c-.00201-.05884-.05136-.10489-.1102-.10287-.056,.00192-.10095,.04688-.10287,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M305.12888,223.44169l.46469,6.13348,.46338,6.11581,.26114,3.44678c.01028,.13589,.22345,.13699,.21307,0l-.46469-6.13348-.46338-6.11581-.26114-3.44678c-.01028-.13589-.22345-.13699-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M309.17224,224.15647l.28021,5.61206c.09338,1.8707-.38141,3.74139-.28799,5.61206l.15735,3.15125c.00681,.13647,.21994,.13727,.21307,0-.09341-1.8707,.38141-3.74139,.28799-5.61206l-.28018-5.61206-.15735-3.15125c-.00684-.13647-.21997-.13733-.2131,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.82622,
    cy: 208.2127,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#e6e6e6"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.01106,
    cy: 209.49116,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#3f3d56"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.76649,
    cy: 212.26113,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#ff6584"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.52071,
    cy: 213.21913,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.7975,
    cy: 214.02711,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.21895,
    cy: 215.77773,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.35039,
    cy: 215.20783,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.62721,
    cy: 216.0158,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.04866,
    cy: 217.76644,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.68839,
    cy: 213.62371,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(41.11385 474.41449) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.44072,
    cy: 216.7596,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(36.92993 475.88636) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.33142,
    cy: 211.9849,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(40.70206 470.66445) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.29938,
    cy: 211.91914,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(47.64759 478.50107) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.0517,
    cy: 215.05498,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(43.46372 479.97287) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.9424,
    cy: 210.2803,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(47.23582 474.75099) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.81942,
    cy: 208.44863,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(52.39916 477.01097) rotate(-82.1552)",
    fill: "#3f3d56"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.71237,
    cy: 203.67499,
    rx: 0.5162,
    ry: 0.3591,
    transform: "translate(56.17119 471.79131) rotate(-82.15499)",
    fill: "#ff6584"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M500.10046,233.4712h-21.73145c-.58398,0-3.80103-1.70175-3.80103-3.80099v-12.07199c-.10394-9.13107,29.78882-9.72873,29.90155,0v12.07199c.00006,2.09927-2.2699,3.80099-4.36908,3.80099Z",
    fill: "#e6e6e6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M501.22498,209.41538c-1.0542-.37717-2.17365-.53763-3.29132-.47174,.29895-.09885,.57355-.25977,.80591-.47223-.20428-.00821-.40741-.03555-.60657-.08173-.21948-.0412-.42615-.13367-.60315-.26984-.17798-.1402-.27313-.36081-.25293-.58649,.04065-.27612,.29865-.50345,.27216-.78125-.0304-.31839-.39777-.47336-.59436-.72562-.24622-.39053-.20386-.89694,.10376-1.24115,.18683-.21753,.41547-.39529,.67236-.52267-.43384-.11145-.88959-.10486-1.32001,.01913,.4613-.35709,.6662-.95416,.52142-1.51926-.24359-.70346-.82178-1.23926-1.54175-1.42865-.71027-.17902-1.44537-.23837-2.17511-.17566,.6203-.19058,.52679-1.16232,.05267-1.60532s-1.15222-.62799-1.59937-1.09827-.41095-1.47421,.23328-1.55228l-.07922-.22916c-1.2829-.4791-2.7113,.17255-3.19037,1.45544-.04102,.1098-.07416,.22238-.09924,.33688-.11804,.73529,.10187,1.54865-.26709,2.19556-.4704,.82477-1.61218,.91809-2.55725,.82666-.92792-.23801-1.91205-.10367-2.74225,.37427-.6864,.57178-.77936,1.59174-.20758,2.27817,.31732,.38098,.79187,.59537,1.28748,.5817-.62183,.0043-1.24072,.086-1.84241,.24319l.57947,.22458c.12891,.03986,.24786,.10666,.349,.19601,.10168,.09366,.13293,.24142,.07788,.36823-.09265,.168-.33203,.1622-.52179,.13367l-1.25983-.18954c.25061,.08362,.38593,.35452,.30231,.6051s-.35449,.38596-.6051,.30234c-.06427-.02145-.12323-.0563-.17303-.10226,.12939,.15109,.2334,.32217,.30798,.50656,.07404,.18799,.05219,.40021-.05847,.56924-.2561,.23477-.63318,.28067-.93817,.1142-.10254-.03943-.20575-.08533-.30969-.12735,.00208,.03644,.00482,.07294,.00909,.1095,.06964,.48407,.33929,.91663,.74329,1.19223-.57117,.0665-1.09705,.34344-1.47504,.77676-.6557,.81448-.69525,1.96396-.09705,2.82156-.63556-.28107-1.33203-.39645-2.02429-.33539-.71161,.08762-1.24487,.69424-1.24048,1.41122,.11469,.8782,1.20215,1.19931,2.08112,1.3082,6.91156,.85065,13.90137,.84982,20.81268-.0025,.93896-.06348,1.85852-.29739,2.71362-.69034,.86499-.40936,1.46027-1.23297,1.57758-2.18274-.03723-1.14432-.75928-2.1539-1.83014-2.55899Z",
    fill: "#8e28f5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M506.35522,219.58906c-.15759-.68338-.76764-1.16635-1.46893-1.16309-.66803,.01755-1.26508,.4946-1.92102,.39017-.54468-.08673-.97253-.56219-1.52039-.48959-.50171,.06647-.77142,.55682-1.14606,.82059h-.96094c-.37408-.29449-.55792-.89114-1.07678-1.05844-.78156-.25201-1.40863,.62991-2.22717,.78595-.47382,.05261-.95251-.03879-1.37366-.2623-.41223-.22385-.85974-.37537-1.32318-.448-.41614-.06253-.83118,.11972-1.06677,.46844,.02545-.24957-.29883-.49426-.62817-.51001-.36786,.01346-.72571,.12372-1.03741,.31958-.31287,.19583-.67468,.29932-1.04376,.29855-.81775-.07123-1.21875-1.0267-2.04102-1.03708-1.03497-.01309-1.4491,1.46124-2.4726,1.33557-.53223-.06534-.81946-.54861-1.29401-.75528-.5036-.15472-1.04126-.15997-1.54773-.01511l-2.42078,.45316c-.70953,.19592-1.45789,.20325-2.17114,.0213-.51923-.18787-1.02362-.5947-1.55902-.43985-.46637,.13486-.69397,.6572-1.18781,.68433-.31549-.03983-.61945-.14386-.89319-.30566-.52344-.18539-1.10706-.03821-1.47992,.37329-.271,1.1041-.31494,2.25174-.12903,3.37329-.00732,.23907,.0116,.47824,.05646,.71317l2.43475,9.74323c.28625,1.49429,1.02515,2.57474,2.54657,2.57474h23.66412c1.52142,0,2.82855-1.08044,3.11481-2.57474l2.43475-9.74323c.00482-.02524,.00793-.05032,.01215-.0755,.05762-1.16608-.03412-2.33472-.27313-3.47748Z",
    fill: "#ccc"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M477.42218,218.85581l.47314,6.14999c.15771,2.04999-.07574,4.07156,.08197,6.12155,.08881,1.1546,.56879,2.33765,.65765,3.49225,.01044,.13586,.22363,.13699,.21307,0l-.47314-6.14999-.47314-6.14999-.26648-3.46381c-.01044-.13583-.22363-.13699-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M481.53174,219.09931l.18439,6.06033,.18439,6.06033,.10352,3.40228c.00415,.13681,.21722,.13739,.21307,0l-.18439-6.06033-.18439-6.06033-.10352-3.40228c-.00415-.13681-.21722-.13739-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M485.51318,219.46287l-.05609,5.85687-.05573,5.82138-.03162,3.30115c.00201,.05884,.05139,.10489,.11023,.10287,.05597-.00192,.10089-.04688,.10284-.10287l.05609-5.85687,.05573-5.82138,.03162-3.30115c-.00201-.05884-.05139-.10489-.11023-.10287-.05597,.00192-.10089,.04688-.10284,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M488.52094,219.2837l.11664,5.9292,.11591,5.89371,.06561,3.3374c.00201,.05884,.05139,.10489,.11023,.10287,.05597-.00192,.10089-.04688,.10284-.10287l-.11664-5.9292-.11591-5.89371-.06561-3.3374c-.00201-.05884-.05139-.10489-.11023-.10287-.05597,.00192-.10089,.04688-.10284,.10287Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M492.9043,219.04023l.1333,6.08734,.1333,6.08734,.07465,3.4075c.00201,.05884,.05139,.10489,.11023,.10287,.05597-.00192,.10089-.04688,.10284-.10287l-.1333-6.08734-.1333-6.08734-.07465-3.4075c-.0022-.05884-.05164-.10477-.11047-.1026-.05579,.00208-.10052,.04681-.1026,.1026Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M496.54309,219.22477l.46472,6.13348,.46338,6.11581,.26117,3.44678c.01031,.13589,.22345,.13699,.21307,0l-.46472-6.13348-.46338-6.11581-.26117-3.44678c-.01031-.13586-.22345-.13699-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M500.58643,219.93955l.28021,5.61206c.09338,1.8707-.38141,3.74139-.28802,5.61206l.15735,3.15125c.00684,.13647,.21991,.1373,.21307,0-.09338-1.8707,.38141-3.74139,.28802-5.61206l-.28021-5.61206-.15735-3.15125c-.00684-.13647-.21991-.13727-.21307,0Z",
    isolation: "isolate",
    opacity: 0.2
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.2404,
    cy: 203.99581,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#e6e6e6"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.42522,
    cy: 205.27426,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#3f3d56"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.18068,
    cy: 208.04424,
    rx: 0.8168,
    ry: 0.56821,
    fill: "#ff6584"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.93486,
    cy: 209.00222,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.21169,
    cy: 209.8102,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.63313,
    cy: 211.56085,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 497.76457,
    cy: 210.99093,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#e6e6e6"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 501.0414,
    cy: 211.79891,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#3f3d56"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.46281,
    cy: 213.54954,
    rx: 0.5162,
    ry: 0.3591,
    fill: "#ff6584"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 484.10257,
    cy: 209.40682,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(210.5786 660.3959) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.85489,
    cy: 212.54271,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(206.39468 661.86776) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.7456,
    cy: 207.76807,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(210.16675 656.64592) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 489.71354,
    cy: 207.70219,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(217.11239 664.4824) rotate(-82.15499)",
    fill: "#e6e6e6"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 488.46585,
    cy: 210.83814,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(212.92839 665.9543) rotate(-82.15499)",
    fill: "#3f3d56"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.35656,
    cy: 206.06338,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(216.70059 660.73235) rotate(-82.15499)",
    fill: "#ff6584"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.23289,
    cy: 204.2319,
    rx: 0.51623,
    ry: 0.3591,
    transform: "translate(221.86383 662.9919) rotate(-82.1552)",
    fill: "#3f3d56"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490.12656,
    cy: 199.4581,
    rx: 0.51624,
    ry: 0.3591,
    transform: "translate(225.63596 657.77273) rotate(-82.15499)",
    fill: "#ff6584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksheet);
export default __webpack_public_path__ + "static/media/worksheet.800b4d2132dda2de676b52adcb28fdfc.svg";
export { ForwardRef as ReactComponent };